module.exports = __webpack_public_path__ + "img/checked_radio.d76b146a.svg";